var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Status flex"},[_c('WIcon',{attrs:{"icon":_vm.icon,"color":_vm.iconColor,"size":20}}),_c('WText',{attrs:{"tag":"span","size":14}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }